import { render } from "./videoGuides.vue?vue&type=template&id=77a415a4&scoped=true"
import script from "./videoGuides.vue?vue&type=script&lang=js"
export * from "./videoGuides.vue?vue&type=script&lang=js"

import "./videoGuides.vue?vue&type=style&index=0&id=77a415a4&lang=scss&scoped=true"

import exportComponent from "/var/www/likvio.se/html/likvio-fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77a415a4"]])

export default __exports__